import { TFunction } from 'i18next'
import { Know } from 'interfaces/Know'
import { Knower } from 'interfaces/Knower'

export const returnKnowerFollowerLabel = (know: Know, t: TFunction<'knows'>, locale: string | undefined) => {
    return `${know?.knower?.followerCount.toLocaleString(locale) ?? '0'} ${t(
        know?.knower?.followerCount > 1 ? 'knows/knowerMultipleFollowersCount' : 'knows/knowerSingularFollowerCount'
    )}`
}

export const returnKnowerFollowersLabel = (knower: Knower, t: TFunction<'knows'>, locale: string | undefined) => {
    return `${knower?.followerCount.toLocaleString(locale) ?? '0'} ${t(
        knower?.followerCount > 1 ? 'knows/knowerMultipleFollowersCount' : 'knows/knowerSingularFollowerCount'
    )}`
}
